import PubSub from "pubsub-js";
import { events } from "./Events";

export default class SectionOrderRenderer {
  constructor() {}

  init() {
    this.dataFetchToken = PubSub.subscribe(events.DATA_FETCHED, (msg, data) => {
      if (data.order.length) {
        this.render(data.order);
        PubSub.unsubscribe(this.dataFetchToken);
      };
    });
  }

  render(orderData) {
    orderData.forEach(item => {
      const sectionEl = document.querySelector(`#${item.section}`);
      const menuEl = document.querySelector(`.menu__item--${item.section}`);

      if (sectionEl) {
        sectionEl.style.order = item.order;

        if (!item.visible) {
          sectionEl.style.display = 'none';
        }
      }

      if (menuEl) {
        menuEl.style.order = item.order;

        if (!item.visible) {
          menuEl.style.display = 'none';
        }
      }
    })
  }
}